import { render, staticRenderFns } from "./ModuleDataBatchSync.vue?vue&type=template&id=4ffc19d9"
import script from "./ModuleDataBatchSync.vue?vue&type=script&lang=js"
export * from "./ModuleDataBatchSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports